import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import DOM from 'react-dom-factories';
import _ from 'lodash';
import template from './sortByDragListBase.jsx';
import compose from '../../hoc/compose';
var LEFT_BUTTON_QUERY = 0;

var shouldIgnoreMouseEvent = function shouldIgnoreMouseEvent(e) {
  return e.button !== LEFT_BUTTON_QUERY;
};

var SortByDragListBase = /*#__PURE__*/function (_React$Component) {
  _inherits(SortByDragListBase, _React$Component);

  var _super = _createSuper(SortByDragListBase);

  function SortByDragListBase(props) {
    var _this;

    _classCallCheck(this, SortByDragListBase);

    _this = _super.call(this, props);
    _this.state = {
      placeHolderIndex: -1,
      items: null
    };
    _this.isMouseDown = false;
    _this.endDragPending = false;

    _this.getTransitionClass = function () {
      return _this.props.childrenTransition || DOM.div;
    };

    _this.getItems = function () {
      if (_this.endDragPending) {
        var items = _this.props.children.slice();

        var itemToMove = items.splice(_this.fromIndex, 1)[0];
        items.splice(_this.toIndex, 0, itemToMove);
        return items;
      }

      if (_this.state.items) {
        var placeholder = /*#__PURE__*/React.createElement('div', {
          className: _this.props.dragPlaceholderCssClass || 'drag-placeholder',
          key: 'placeholder',
          ref: 'placeholder',
          style: {
            width: _this.clientRect.width + 'px',
            height: _this.clientRect.height + 'px'
          }
        });

        var _items = _this.state.items.slice();

        _items[_this.fromIndex] = placeholder;

        if (_this.fromIndex !== _this.state.placeHolderIndex) {
          var _itemToMove = _items.splice(_this.fromIndex, 1)[0];

          _items.splice(_this.state.placeHolderIndex, 0, _itemToMove);
        }

        return _items;
      }

      return _this.props.children;
    };

    _this.initDragProcess = function (itemIndex, event) {
      window.document.addEventListener('mousemove', _this.onMouseMove);
      window.document.addEventListener('mouseup', _this.onMouseUp, true);
      _this._dragProcessStarted = true;
      _this._realDragStarted = false;
      _this.fromIndex = itemIndex;
      _this.toIndex = _this.fromIndex;
      _this.dragged = event.currentTarget; //check target vs currentTarget

      _this.parentNode = _this.dragged.parentNode;
      _this.clientRect = _this.dragged.getBoundingClientRect();
      _this.originalTop = _this.dragged.offsetTop;
      _this.initParentTop = _this.parentNode.getBoundingClientRect().top;
      _this.currentY = _this.clientRect.top;
      _this.currentBottomY = _this.clientRect.bottom;
      _this.clientYOnStart = event.clientY;
      _this.deltaY = _this.clientYOnStart - _this.clientRect.top;
      _this.maxTop = _this.parentNode.clientHeight - _this.clientRect.height;
    };

    _this.endDragProcess = function (event) {
      if (!_this._dragProcessStarted) {
        return;
      }

      window.document.removeEventListener('mousemove', _this.onMouseMove);
      window.document.removeEventListener('mouseup', _this.onMouseUp, true);

      if (_this._realDragStarted) {
        _this.endRealDrag();

        event.stopPropagation();
      }
    };

    _this.startRealDrag = function () {
      var _this2 = this;

      this._realDragStarted = true;

      if (_.isFunction(this.props.beforeDragStart)) {
        this.props.beforeDragStart(this.fromIndex);
      }

      var items = this.props.children.slice();
      var dragged = items.splice(this.fromIndex, 1, {
        thisitem: 'is a placeholder for the placeholder'
      });
      items = items.concat(dragged);
      this.setState({
        placeHolderIndex: this.fromIndex,
        items: items
      }, function () {
        _this2.dragged.style.position = 'absolute';
        _this2.dragged.style.width = '100%';
        _this2.dragged.style.top = _this2.originalTop + 'px';
      });
    };

    _this.afterDragEnd = function () {
      this.dragged.style.position = 'relative';
      this.dragged.style.top = '';
      this.setState({
        placeHolderIndex: -1,
        items: null
      }, function () {
        if (_.isFunction(this.props.onItemMoved) && this.fromIndex !== this.toIndex) {
          this.props.onItemMoved(this.fromIndex, this.toIndex);
        }

        if (_.isFunction(this.props.afterDragEnd)) {
          this.props.afterDragEnd(this.fromIndex, this.toIndex);
        }
      }.bind(this));
    };

    _this.endRealDrag = function () {
      var _this3 = this;

      if (_.isFunction(this.props.onItemMovedAsync) && this.fromIndex !== this.toIndex) {
        this.endDragPending = true;
        this.props.onItemMovedAsync(this.fromIndex, this.toIndex).then(function () {
          _this3.endDragPending = false;

          _this3.afterDragEnd();
        });
      } else {
        this.afterDragEnd();
      }
    };

    _this.resetMouseDown = function () {
      _this.isMouseDown = false;
      window.document.removeEventListener('mouseup', _this.resetMouseDown);
    };

    _this.expectOnClick = function () {
      _this.isMouseDown = true;
      window.document.addEventListener('mouseup', _this.resetMouseDown);
    };

    _this.ensureUserDragsListItem = function (itemIndex, event) {
      setTimeout(function () {
        if (_this.isMouseDown) {
          _this.resetMouseDown();

          _this.initDragProcess(itemIndex, event);
        }
      }, 150);
    };

    _this.onMouseDown = function (itemIndex, event) {
      event.stopPropagation();

      if (!_this.props.draggable) {
        return;
      }

      if (shouldIgnoreMouseEvent(event)) {
        return _this.endDragProcess(event);
      }

      _this.expectOnClick();

      var copyEvent = _objectSpread({}, event);

      _this.ensureUserDragsListItem(itemIndex, copyEvent);
    };

    _this.onMouseMove = function (event) {
      if (!_this._realDragStarted) {
        _this.startRealDrag();
      }

      var currentParentTop = _this.parentNode.getBoundingClientRect().top;

      var scrollOffset = _this.initParentTop - currentParentTop;
      var mouseDeltaY = event.clientY - _this.clientYOnStart;
      _this.dragged.style.top = Math.min(Math.max(mouseDeltaY + _this.originalTop + scrollOffset, 0), _this.maxTop) + 'px';
      var children = _this.parentNode.children;
      var nextRealSiblingInList = _this.toIndex + 1 !== _this.state.items.length && children[_this.toIndex + 1] !== _this.dragged && children[_this.toIndex + 1];
      var prevRealSiblingInList = _this.toIndex > 0 && children[_this.toIndex - 1] !== _this.dragged && children[_this.toIndex - 1];
      var shouldSwitchWithNext = Boolean(event.clientY > _this.currentBottomY && nextRealSiblingInList);
      var shouldSwitchWithPrev = Boolean(event.clientY < _this.currentY && prevRealSiblingInList);

      if (shouldSwitchWithNext) {
        _this.currentBottomY = nextRealSiblingInList.getBoundingClientRect().bottom;
        _this.currentY = _this.currentBottomY - _this.clientRect.height;
        _this.toIndex += 1;
      } else if (shouldSwitchWithPrev) {
        _this.currentY = prevRealSiblingInList.getBoundingClientRect().top;
        _this.currentBottomY = _this.currentY + _this.clientRect.height;
        _this.toIndex -= 1;
      }

      if (shouldSwitchWithNext || shouldSwitchWithPrev) {
        var placeHolderIndex = _this.toIndex;

        _this.setState({
          placeHolderIndex: placeHolderIndex
        });
      }

      event.stopPropagation();
    };

    _this.onMouseUp = function (event) {
      return _this.endDragProcess(event);
    };

    return _this;
  }

  _createClass(SortByDragListBase, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return !this.endDragPending;
    }
  }, {
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return SortByDragListBase;
}(React.Component);

SortByDragListBase.displayName = 'SortByDragListBase';
SortByDragListBase.propTypes = {
  childrenTransition: PropTypes.func,
  // React.addons.TransitionGroup class
  transitionProps: PropTypes.object,
  // The props for the TransitionGroup component,
  draggable: PropTypes.bool,
  onItemMoved: PropTypes.func,
  onItemMovedAsync: PropTypes.func,
  // Should be used when you need to ensure `afterDragEnd` executes only after `onItemMovedAsync` is done
  beforeDragStart: PropTypes.func,
  afterDragEnd: PropTypes.func,
  dragPlaceholderCssClass: PropTypes.string
};
SortByDragListBase.defaultProps = {
  draggable: true
};
export default compose(SortByDragListBase);